document.addEventListener("DOMContentLoaded", function () {
    const stickyForm = document.querySelector(".sticky-form");

    /** Real Buttons */
    const atcButton = document.querySelector(".add_to_cart[name='add']");
    const quantity = document.getElementById("quantity");
    
    /** Fake Buttons 
     * This button is used to trigger the real button
     */
    const fakeQuantity = document.querySelector(".quantity.quantity-fake");
    const fakeAtcButton = document.getElementById("fake-add-to-cart");

    /** Listeners */
    fakeAtcButton.addEventListener("click", () => {
        const span = fakeAtcButton.querySelector("span");
        const checkmark = fakeAtcButton.querySelector(".checkmark");
        
        // Disabled the fake button for animations
        fakeAtcButton.setAttribute("disabled", "disabled");
        fakeAtcButton.classList.add("disabled");
        
        span.classList.add("disabled");
        span.classList.remove("fadeInDown");
        span.classList.add("animated");
        span.classList.add("zoomOut");
        checkmark.classList.add("checkmark-active");

        //Set quantity and trigger real button
        quantity.value = fakeQuantity.value;
        atcButton.click();

        const interval = setInterval(() => {
            //Check that real button is not disabled
            if(!atcButton.disabled === false) {
                // Remove the disabled attribute
                setTimeout(() => {
                    fakeAtcButton.classList.remove("disabled");
                    fakeAtcButton.removeAttribute("disabled");
                    checkmark.classList.remove("checkmark-active");
                    span.classList.remove("zoomOut");
                    span.classList.add("fadeInDown");
                    clearInterval(interval);//Stop interval
                }, 1000);
            }
        }, 1000);
    });

    const onObserver = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // entered viewport at the top edge, hence scroll direction is up
                stickyForm.classList.remove('is-active');
            } else {
                // left viewport at the top edge, hence scroll direction is down
                stickyForm.classList.add('is-active');
            }
        });
    };

    const options = {
        rootMargin: '0px 0px 100% 0px'
    };

    const observer = new IntersectionObserver(onObserver, options);
    observer.observe(atcButton);
});
